<template>
  <div :id="$domain.publitas.id" />
</template>

<script lang="ts" setup>
import { useCart } from '~/composables/custom/useCart/useCart';

const { refresh } = useCart();

const { $domain } = useNuxtApp();
interface Props {
  publication: string;
}
const props = withDefaults(defineProps<Props>(), {
  publication: '',
});

const publication = toRef(props, 'publication', '');

useHead({
  script: [
    {
      'src': 'https://view.publitas.com/embed.js',
      'type': 'application/javascript',
      'async': true,
      'data-cfasync': 'false',
      'data-height': 'undefined',
      'data-publication': publication.value,
      'data-publication-aspect-ratio': 'undefined',
      'data-responsive': 'true',
      'data-width': 'undefined',
      'data-wrapper-id': $domain.publitas.id,
      'publitas-embed': true,
    },
  ],
});

const observer = ref();

onMounted(() => {
  observer.value = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === 'aria-hidden' && mutation.target.id === 'pb-kik' && mutation.target.ariaHidden === 'true') {
        refresh();
      }
    }
  });

  observer.value.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });
});

onBeforeUnmount(() => {
  observer.value?.disconnect();
});

useHead({
  script: {
    src: 'https://scripts.publitas.com/plugins/ecom-light/website.js',
    type: 'text/javascript',
  },
});
</script>
